// BNB Address
const BNB_ADDRESS = '0x18e6CAE78DCe617165d1f67BFf379cc54201c58d'

export { BNB_ADDRESS }
